import type { IHeroBanner } from '~/components/widget/hero-banner'

const heroBanners: IHeroBanner[] = [
  {
    intro: 'page.home.banners.credits.intro',
    heading: 'page.home.banners.credits.heading',
    text: 'page.home.banners.credits.text',
    image: '/images/photostock/credits.avif',
    illustration: 'credits',
    tab: 'common.credits',
    actionBtn: { url: '/credits', label: 'page.home.banners.credits.action_btn' },
    additionalActionBtn: {
      url: '/credits/online-request',
      label: 'page.home.banners.credits.additional_action_btn'
    }
  },
  {
    intro: 'common.help_you_find',
    heading: 'page.home.banners.deposits.heading',
    text: 'page.home.banners.deposits.text',
    image: '/images/photostock/deposits.png',
    illustration: 'deposits',
    tab: 'common.deposits',
    actionBtn: { url: '/deposits', label: 'page.home.banners.deposits.action_btn' }
  }
]

export default heroBanners
